import { create } from "zustand";
import { GPS } from "../../util/geo";
import { config } from "../state/config";
import { Cube } from "../state/types";
import { FetchState } from "../state/util";

// Eigen kavelselectie, bewust niet de globale useSelection: die stuurt de
// selectielaag op de globale kaart en het rapport op /location aan. Zelfde bron
// (de reference-service), andere staat.
interface KavelState {
  state?: FetchState;
  gps?: GPS;
  cube?: Cube;
  error?: string;
  // Het volledige rapport staat open (het kaartje met kerngegevens is er altijd).
  showReport: boolean;
  select: (gps: GPS) => Promise<void>;
  openReport: () => void;
  hideReport: () => void;
  clear: () => void;
}

export const useWorkspaceKavel = create<KavelState>((set, get) => ({
  showReport: false,
  openReport: () => set({ showReport: true }),
  hideReport: () => set({ showReport: false }),

  select: async (gps: GPS) => {
    if (get().state === "fetched" && get().gps?.join() === gps.join()) return;
    set({ gps, state: "fetching", cube: undefined, error: undefined });
    try {
      const response = await fetch(`${config.referenceUrl}/api/cube?c=${gps[0]},${gps[1]}`);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const cube: Cube = await response.json();
      // Ondertussen kan er een ander kavel zijn aangeklikt.
      if (get().gps?.join() !== gps.join()) return;
      set({ state: "fetched", cube });
    } catch {
      if (get().gps?.join() !== gps.join()) return;
      set({ state: "error", error: "Kon dit kavel niet ophalen" });
    }
  },
  clear: () =>
    set({
      state: undefined,
      gps: undefined,
      cube: undefined,
      error: undefined,
      showReport: false,
    }),
}));
